import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityFormComponent } from './entity-form/entity-form.component';
import { EntityComponent } from './entity/entity.component';
import { SharedModule } from '../../shared/shared.module';
import { ExplainPlanDialogComponent } from './explain-plan-dialog/explain-plan-dialog.component';
import { ThirdPartyModule } from 'src/app/modules/third-party.module';
import { QueryResultDialogComponent } from './query-result-dialog/query-result-dialog.component';

@NgModule({
  declarations: [
    EntityComponent,
    EntityFormComponent,
    ExplainPlanDialogComponent,
    QueryResultDialogComponent,
  ],
  imports: [
    CommonModule,
    ThirdPartyModule,
    SharedModule.forRoot()
  ],
  entryComponents:[
    ExplainPlanDialogComponent,
    QueryResultDialogComponent
  ],
  exports:[
  ]
})
export class EntityModule { }
